import React from 'react';
import { Search, Filter } from 'lucide-react';

interface PrinterFiltersProps {
    searchTerm: string;
    onSearchChange: (value: string) => void;
    statusFilter: 'all' | 'available' | 'unavailable' | 'error';
    onStatusFilterChange: (value: 'all' | 'available' | 'unavailable' | 'error') => void;
    totalCount: number;
    filteredCount: number;
}

export const PrinterFilters: React.FC<PrinterFiltersProps> = ({
    searchTerm,
    onSearchChange,
    statusFilter,
    onStatusFilterChange,
    totalCount,
    filteredCount,
}) => {
    const filterButtons: Array<{ value: 'all' | 'available' | 'unavailable' | 'error'; label: string }> = [
        { value: 'all', label: 'Todas' },
        { value: 'available', label: 'Online' },
        { value: 'unavailable', label: 'Offline' },
        { value: 'error', label: 'Error' },
    ];

    return (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-4 mb-4">
            <div className="flex flex-col md:flex-row gap-4">
                {/* Search Bar */}
                <div className="flex-1">
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
                        <input
                            type="text"
                            placeholder="Buscar por nombre de impresora..."
                            value={searchTerm}
                            onChange={(e) => onSearchChange(e.target.value)}
                            className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        />
                    </div>
                </div>

                {/* Status Filters */}
                <div className="flex items-center gap-2">
                    <Filter size={18} className="text-slate-500" />
                    <div className="flex gap-2">
                        {filterButtons.map((button) => (
                            <button
                                key={button.value}
                                onClick={() => onStatusFilterChange(button.value)}
                                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${statusFilter === button.value
                                        ? 'bg-green-600 text-white'
                                        : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                                    }`}
                            >
                                {button.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Results Counter */}
            {(searchTerm || statusFilter !== 'all') && (
                <div className="mt-3 pt-3 border-t border-slate-200">
                    <p className="text-sm text-slate-600">
                        Mostrando <span className="font-semibold text-slate-900">{filteredCount}</span> de{' '}
                        <span className="font-semibold text-slate-900">{totalCount}</span> impresoras
                    </p>
                </div>
            )}
        </div>
    );
};
